"use client"
import { useRouter } from "next/navigation";
import { Home } from "lucide-react"; // Keep this, remove react-icons
import HomeIcon from '@mui/icons-material/Home';
import React, { useCallback } from "react";
// REMOVE: import { FaHome } from "react-icons/fa";

// Move out of component to avoid new object each render
const COLORS = {
  primaryColor: "#00489b",
  kWhite: "#FFFFFF",
};

const ServiceOfDayBar = React.memo(function ServiceOfDayBar({ serviceData }) {
  const router = useRouter();

  // Memoize the click handler
  const handleBookNow = useCallback(() => {
    router.push(`/subcategory/${serviceData.subCategoryId}`);
  }, [router, serviceData?.subCategoryId]);

  // Early return for null data
  if (!serviceData) return null;

  return (
    <div className="flex justify-center px-3">
      <div className="w-full max-w-[1200px] rounded-[18px] bg-gradient-to-br from-[#FF6A00] to-[#FFA800]
 p-2 xs:p-2 sm:p-3 shadow-md ring-1 ring-white/10 flex items-center justify-between gap-2 xs:gap-3 ">
        {/* Left */}
        <div className="flex items-center gap-2 xs:gap-3 sm:gap-4 min-w-0">
          <span className="w-6 h-6 xs:w-7 xs:h-7 sm:w-8 sm:h-8 rounded-full flex items-center justify-center flex-shrink-0 ml-1">
            {/* FIXED: Use Lucide Home instead of FaHome */}
            <HomeIcon className="h-4 w-4 xs:h-5 xs:w-5 text-white" />
          </span>
          <div className="flex flex-col min-w-0">
            <span className="text-white text-[13px] xs:text-sm sm:text-base font-semibold tracking-wide">
              Service of the Day 
            </span>
            <div className="flex items-center gap-1 xs:gap-2 flex-nowrap">
              <span className="text-white/90 text-[11px] xs:text-xs sm:text-sm truncate max-w-[55%]">
                {serviceData.title ?? "—"}
              </span>
              {typeof serviceData.discountPercentage === "number" && (
                <span className="inline px-1.5 py-0.5 rounded-full bg-white/20 text-white text-[10px] sm:text-xs font-medium whitespace-nowrap">
                  {serviceData.discountPercentage}% off today
                </span>
              )}
            </div>
          </div>
        </div>
        
        {/* Right */}
        {/* <div className="hidden sm:flex flex-shrink-0">
          <button
            // onClick={handleBookNow}
            className="bg-white text-xs sm:text-sm font-semibold rounded-full px-3 py-1 sm:px-3.5 sm:py-1.5 text-[#00489b] shadow-sm hover:shadow-md transition duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
            tabIndex={0}
            aria-label="Book Now for Service of the Day"
          >
            Book Now
          </button>
        </div> */}
      </div>
    </div>
  );
});

export default ServiceOfDayBar;
